/* kc-pack — "Sistemini kur" radyo katmanı, çoklu-paket teklifleri (pilot: GoCube, 2026-10-02).
   Bağımsız, ES2018, derleme yok. Veri: snippets/kc-pack.liquid (parent + offers JSON).
   Sepet yükü eski kc-bundle-selector ile birebir: parent + child satırları, _bundle_* özellikleri,
   _kc_bundle_<uid> attribute'ları → Cart Transform tek satıra birleştirir, Discount Function yüzdeyi keser.
   Form submit gövdede capture ile yakalanır (Focal <product-form> + tb-drawer'dan önce). */
(function () {
  'use strict';
  if (window.customElements.get('kc-pack')) return;

  var HEX = { 'Lacivert': '#053769', 'Bej': '#e5e3d4', 'Kahverengi': '#6b5547', 'Siyah': '#131313', 'Yeşil': '#18454b', 'Noir': '#100f13', 'Ash': '#323134', 'Dune': '#c9bb9a', 'Gri': '#a9a9a8', 'Mavi': '#2551b5' };

  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  // Mağaza para biçimi (2026-10-02): {{amount_with_comma_separator}} TL → "2.800,00 TL"
  function fmt(c) { return (c / 100).toLocaleString('tr-TR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' TL'; }
  function fmtTl(c) { return Math.round(c / 100).toLocaleString('tr-TR') + ' TL'; }
  function sizeShort(v) { return String(v || '').split(' (')[0].trim(); }
  function ss(k, v) {
    try {
      if (v === undefined) return JSON.parse(sessionStorage.getItem(k) || 'null');
      if (v === null) sessionStorage.removeItem(k); else sessionStorage.setItem(k, JSON.stringify(v));
    } catch (e) { return null; }
  }
  function track(name, data) {
    try { (window.dataLayer = window.dataLayer || []).push(Object.assign({ event: name }, data || {})); } catch (e) {}
    try { if (typeof window.clarity === 'function') window.clarity('event', name); } catch (e) {}
  }
  function uuid() { return (window.crypto && crypto.randomUUID) ? crypto.randomUUID() : Date.now() + '-' + Math.random().toString(36).slice(2, 10); }

  function instFor(form) {
    var fid = form && form.getAttribute('id');
    if (!fid) return null;
    var el = document.querySelector('kc-pack[data-form="' + fid + '"]');
    return el && el._ready && el.sel !== 'only' ? el : null;
  }
  document.body.addEventListener('submit', function (e) {
    var form = e.target;
    if (!(form instanceof HTMLFormElement) || !/\/cart\/add/.test(form.action || '')) return;
    var el = instFor(form);
    if (!el) return;
    e.preventDefault(); e.stopImmediatePropagation(); e.stopPropagation();
    el._submit(form);
  }, true);
  // Selleasy ATC popup'ı: teklif seçiliyken açılmaz (kc-set ile aynı yöntem: window capture → requestSubmit)
  window.addEventListener('click', function (e) {
    var b = e.target && e.target.closest && e.target.closest('button');
    if (!b || !b.form || (b.type || 'submit') !== 'submit') return;
    var el = instFor(b.form);
    if (!el) return;
    e.preventDefault(); e.stopImmediatePropagation();
    if (b.form.requestSubmit) b.form.requestSubmit(b);
    else b.form.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }));
  }, true);

  class KcPack extends HTMLElement {
    connectedCallback() {
      if (this._ready || this._init) return;
      this._init = 1;
      var j = function (el, n) { try { return JSON.parse((el.querySelector('script[data-kcp="' + n + '"]') || {}).textContent || 'null'); } catch (e) { return null; } };
      this.parent = j(this, 'parent'); this.offers = j(this, 'offers') || [];
      if (!this.parent || !this.offers.length) return;
      var self = this, p = this.parent;
      this.byHandle = {}; this.offers.forEach(function (o) { self.byHandle[o.handle] = o; });
      this.sizeIdx = p.options.findIndex(function (o) { return o.name === p.sizeOpt; });
      this.colorIdx = p.options.findIndex(function (o) { return o.name === p.colorOpt; });
      this.sizes = this.sizeIdx > -1 ? p.options[this.sizeIdx].values : [];
      this.colors = this.colorIdx > -1 ? p.options[this.colorIdx].values : [];
      this.form = document.getElementById(this.dataset.form);
      this.radio = this.querySelector('[data-kcp="radio"]');
      this.unitColors = {}; this.extraPick = {}; this.panel = false;
      this.sel = ss('kcpack:sel:' + p.id) || 'only';
      if (this.sel !== 'only' && !this.byHandle[this.sel]) this.sel = 'only';
      this._ready = true;
      this.addEventListener('click', this._onClick.bind(this));
      if (this.form) this.form.addEventListener('variant:changed', function () { setTimeout(function () { self.render(); }, 0); });
      this.render();
      if ('IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (en) { en.forEach(function (x) { if (x.isIntersecting && !self._viewed) { self._viewed = 1; track('pack_view', { product: p.handle }); io.disconnect(); } }); }, { rootMargin: '0px 0px -10% 0px' });
        io.observe(this);
      }
    }

    /* ----- data ----- */
    _pv() {
      var id = parseInt((this.form && this.form.querySelector('[name="id"]') || {}).value || this.parent.variantId, 10);
      return this.parent.variants.filter(function (v) { return v.id === id; })[0] || this.parent.variants[0];
    }
    _variant(size, color) {
      var si = this.sizeIdx, ci = this.colorIdx;
      return this.parent.variants.filter(function (v) { return (si < 0 || v.options[si] === size) && (ci < 0 || v.options[ci] === color); })[0] || null;
    }
    _units(o) {
      var pv = this._pv(), pSize = this.sizeIdx > -1 ? pv.options[this.sizeIdx] : '', pColor = this.colorIdx > -1 ? pv.options[this.colorIdx] : '';
      var cols = this.unitColors[o.handle] || [], out = [{ size: pSize, color: pColor, vid: pv.id, price: pv.price, avail: pv.available !== false, isParent: true }];
      var n = this.sizes.length, start = n ? (Math.max(0, this.sizes.indexOf(pSize)) + 1) % n : 0;
      for (var i = 1; i < o.units; i++) {
        var size = n ? this.sizes[(start + i - 1) % n] : pSize, color = cols[i] || pColor, v = this._variant(size, color);
        out.push({ size: size, color: color, vid: v ? v.id : 0, price: v ? v.price : 0, avail: !!(v && v.available), isParent: false });
      }
      return out;
    }
    _extras(o) {
      var self = this, picks = this.extraPick[o.handle] || {};
      return (o.extras || []).map(function (x) {
        var v = x.variants.filter(function (vv) { return vv.id === picks[x.id]; })[0] || x.variants.filter(function (vv) { return vv.available; })[0] || x.variants[0];
        return { extra: x, v: v, avail: !!(v && v.available) };
      });
    }
    _totals(o) {
      var full = 0, ok = true;
      this._units(o).forEach(function (u) { full += u.price; if (!u.avail) ok = false; });
      this._extras(o).forEach(function (x) { full += x.v ? x.v.price : 0; if (!x.avail) ok = false; });
      var save = Math.round(full * o.pct / 100);
      return { full: full, save: save, pay: full - save, ready: ok };
    }
    _sub(o) {
      var self = this, units = this._units(o), bySize = {};
      units.forEach(function (u) { var k = sizeShort(u.size) || '—'; bySize[k] = (bySize[k] || 0) + 1; });
      var order = this.sizes.map(sizeShort), keys = Object.keys(bySize).sort(function (a, b) { return order.indexOf(a) - order.indexOf(b); });
      var parts = keys.map(function (k) { return bySize[k] + ' ' + k; }).join(' · ');
      var s = units.length + ' ' + this.parent.short + (this.sizes.length > 1 ? ' (' + parts + ')' : '');
      (o.extras || []).forEach(function (x) { s += ' + ' + x.title; });
      return s;
    }
    _colorSummary(o) {
      var by = {}; this._units(o).forEach(function (u) { if (u.color) by[u.color] = (by[u.color] || 0) + 1; });
      return Object.keys(by).map(function (c) { return by[c] + ' × ' + c; }).join(' · ');
    }

    /* ----- render ----- */
    render() {
      var self = this, o = this.sel !== 'only' ? this.byHandle[this.sel] : null;
      Array.prototype.forEach.call(this.querySelectorAll('[data-act="sel"]'), function (b) {
        var on = b.dataset.sel === self.sel;
        b.classList.toggle('is-on', on); b.setAttribute('aria-checked', String(on));
        var of = self.byHandle[b.dataset.sel];
        if (of) {
          var small = b.querySelector('small'), txt = (of.badge ? '<i>' + esc(of.badge) + '</i> · ' : '') + esc(self._sub(of));
          if (small && small._kcp !== txt) { small.innerHTML = txt; small._kcp = txt; }
        }
      });
      var old = this.querySelector('[data-kcp="panel"]');
      if (old) old.parentNode.removeChild(old);
      if (o && (this.colors.length > 1 || (o.extras || []).length)) {
        var btn = this.querySelector('[data-act="sel"][data-sel="' + o.handle + '"]');
        var div = document.createElement('div'); div.className = 'kc-pack__x'; div.setAttribute('data-kcp', 'panel');
        div.innerHTML = this._panelHtml(o);
        btn.insertAdjacentElement('afterend', div);
      }
      this._cta(o);
    }
    _panelHtml(o) {
      var self = this, units = this._units(o), extras = this._extras(o), pv = this._pv(), pColor = this.colorIdx > -1 ? pv.options[this.colorIdx] : '';
      var h = '<div class="kc-pack__sum"><span>Renkler · ' + esc(this._colorSummary(o)) + '</span>';
      h += '<button type="button" class="kc-pack__lnk" data-act="cust" aria-expanded="' + String(this.panel) + '">' + (this.panel ? 'Kapat' : 'Özelleştir') + '</button></div>';
      if (!this.panel) return h;
      h += '<div class="kc-pack__units">';
      units.forEach(function (u, i) {
        h += '<div class="kc-pack__unit' + (u.isParent ? ' is-parent' : '') + '"><span class="kc-pack__ul"><b>' + esc(sizeShort(u.size) || self.parent.short) + '</b>' + (u.isParent ? '<small>seçtiğin</small>' : (u.size ? '<small>' + esc(u.size.replace(/^[^(]*\(|\)$/g, '')) + '</small>' : '')) + '</span>';
        if (u.isParent) { h += '<span class="kc-pack__fixed">' + esc(u.color) + '</span>'; }
        else {
          h += '<span class="kc-set__chips">';
          self.colors.forEach(function (c) {
            var v = self._variant(u.size, c), oos = !(v && v.available);
            h += '<button type="button" class="kc-set__chip' + (c === u.color ? ' is-on' : '') + (oos ? ' is-oos' : '') + '" style="--c:' + (HEX[c] || '#cfc9ba') + '" data-act="chip" data-i="' + i + '" data-color="' + esc(c) + '" aria-label="' + esc(c) + (oos ? ' · tükendi' : '') + '" aria-pressed="' + String(c === u.color) + '"' + (oos ? ' disabled' : '') + '></button>';
          });
          h += '</span>';
        }
        h += '</div>';
      });
      extras.forEach(function (x) {
        h += '<div class="kc-pack__unit"><span class="kc-pack__ul"><b>' + esc(x.extra.title) + '</b></span>';
        if (x.extra.variants.length > 1) {
          h += '<span class="kc-set__chips">';
          x.extra.variants.forEach(function (v) {
            h += '<button type="button" class="kc-set__chip' + (x.v && v.id === x.v.id ? ' is-on' : '') + (v.available ? '' : ' is-oos') + '" style="--c:' + (HEX[v.title] || '#cfc9ba') + '" data-act="xchip" data-eid="' + x.extra.id + '" data-vid="' + v.id + '" aria-label="' + esc(v.title) + (v.available ? '' : ' · tükendi') + '" aria-pressed="' + String(!!(x.v && v.id === x.v.id)) + '"' + (v.available ? '' : ' disabled') + '></button>';
          });
          h += '</span>';
        } else h += '<span class="kc-pack__fixed">' + esc(x.v ? x.v.title : '') + '</span>';
        h += '</div>';
      });
      h += '</div>';
      if ((this.unitColors[o.handle] || []).some(Boolean)) h += '<button type="button" class="kc-pack__lnk kc-pack__reset" data-act="reset">Hepsi ' + esc(pColor) + '</button>';
      return h;
    }
    _priceBox() {
      var sec = this.form && this.form.closest('.product');
      return (sec || document).querySelector('.product-meta__price-list-container');
    }
    _cta(o) {
      var fid = this.dataset.form, self = this, box = this._priceBox();
      var t = o ? this._totals(o) : null;
      var bs = [this.form && this.form.querySelector('[data-product-add-to-cart-button]')].concat(Array.prototype.slice.call(document.querySelectorAll('button[form="' + fid + '"]')));
      bs.forEach(function (b) {
        if (!b || (b.disabled && !self._busy)) return;
        var base = b.getAttribute('data-button-content') || 'Sepete ekle';
        var tgt = b.querySelector('.loader-button__text') || b;
        var h = (box || !t) ? esc(base) : esc(base) + '<span class="kc-set-cta-total">&nbsp;· ' + fmt(t.pay) + '</span>';
        if (tgt._kcp !== h || tgt.innerHTML !== h) { tgt.innerHTML = h; tgt._kcp = h; }
      });
      if (!box) return;
      var el = box.querySelector('.kc-set-price');
      if (!t || !t.ready) { if (el) el.parentNode.removeChild(el); box.classList.remove('kc-set-price-on'); return; }
      if (!el) { el = document.createElement('div'); el.className = 'kc-set-price'; el.setAttribute('aria-live', 'polite'); box.insertBefore(el, box.firstChild); }
      var h2 = '<span class="kc-set-price__now">' + fmt(t.pay) + '</span>';
      if (t.save > 0) h2 += '<span class="kc-set-price__was">' + fmt(t.full) + '</span><span class="kc-set-price__save">' + fmtTl(t.save) + ' avantaj</span>';
      if (el._kcp !== h2) { el.innerHTML = h2; el._kcp = h2; }
      box.classList.add('kc-set-price-on');
    }
    _err(m) { var e = this.querySelector('[data-kcp="err"]'); if (e) { e.textContent = m; e.hidden = !m; } }

    /* ----- events ----- */
    _onClick(e) {
      var b = e.target.closest('[data-act]'); if (!b || !this.contains(b)) return;
      var act = b.dataset.act, o = this.sel !== 'only' ? this.byHandle[this.sel] : null;
      if (act === 'sel') {
        if (this.sel === b.dataset.sel) return;
        this.sel = b.dataset.sel; this.panel = false; this._err('');
        ss('kcpack:sel:' + this.parent.id, this.sel);
        track('pack_sel', { product: this.parent.handle, sel: this.sel });
      } else if (act === 'cust') { this.panel = !this.panel; }
      else if (act === 'chip' && o) { var arr = this.unitColors[o.handle] || (this.unitColors[o.handle] = []); arr[parseInt(b.dataset.i, 10)] = b.dataset.color; }
      else if (act === 'xchip' && o) { var pk = this.extraPick[o.handle] || (this.extraPick[o.handle] = {}); pk[b.dataset.eid] = parseInt(b.dataset.vid, 10); }
      else if (act === 'reset' && o) { this.unitColors[o.handle] = []; }
      else return;
      this.render();
    }

    /* ----- submit ----- */
    _submit(form) {
      var self = this, o = this.byHandle[this.sel];
      if (!o || this._busy) return;
      var units = this._units(o), extras = this._extras(o), t = this._totals(o);
      if (!t.ready) { this._err('Paketteki bir ürün tükendi. Başka bir renk seç.'); return; }
      var uid = o.handle + '-' + uuid(), label = o.title;
      var items = [{ id: units[0].vid, quantity: 1, properties: { _bundle_handle: o.handle, _bundle_label: label, _bundle_role: 'parent', _bundle_uid: uid } }];
      var slot = 0;
      units.slice(1).forEach(function (u) { items.push({ id: u.vid, quantity: 1, properties: { _bundle_handle: o.handle, _bundle_label: label, _bundle_role: 'child', _bundle_uid: uid, _bundle_slot: String(slot++) } }); });
      extras.forEach(function (x) { items.push({ id: x.v.id, quantity: 1, properties: { _bundle_handle: o.handle, _bundle_label: label, _bundle_role: 'child', _bundle_uid: uid, _bundle_slot: String(slot++) } }); });
      var grouped = {};
      units.forEach(function (u) { var k = self.parent.short + ' ' + sizeShort(u.size) + (u.color ? ' ' + u.color : ''); grouped[k] = (grouped[k] || 0) + 1; });
      extras.forEach(function (x) { var k = x.extra.title + (x.v && x.extra.variants.length > 1 ? ' ' + x.v.title : ''); grouped[k] = (grouped[k] || 0) + 1; });
      var summary = Object.keys(grouped).map(function (k) { return (grouped[k] > 1 ? grouped[k] + '× ' : '') + k; }).join(' · ');
      var btn = form.querySelector('[data-product-add-to-cart-button]') || form.querySelector('[type="submit"]');
      var D = window.kcCartDrawer;
      this._busy = true; this._err('');
      if (btn) { btn.setAttribute('aria-busy', 'true'); btn.disabled = true; }
      if (D) { D.open && D.open(); D.setAdding && D.setAdding(true); D.injectPending && D.injectPending({ title: label, image: this.parent.image || '', isBundle: true }); }
      track('pack_atc', { product: this.parent.handle, sel: o.handle, n: items.length, total: t.pay / 100, save: t.save / 100 });
      fetch('/cart/add.js', { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: items }) })
        .then(function (r) {
          return r.json().catch(function () { return {}; }).then(function (body) {
            if (!r.ok) {
              var m = body.description || body.message || '';
              throw new Error(/sold out|stok|tüken/i.test(m) ? 'Paketteki bir ürün tükendi. Başka bir renk seç.' : (m || 'Sepete eklenemedi. Tekrar dene.'));
            }
            var keys = (body.items || []).map(function (i) { return i.key; }).filter(Boolean);
            if (!keys.length) return;
            var attrs = {}; attrs['_kc_bundle_' + uid] = keys.join(','); attrs['_kc_bundle_' + uid + '_variants'] = summary;
            var tries = 0;
            var put = function () {
              return fetch('/cart/update.js', { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ attributes: attrs }) })
                .then(function (a) { if (!a.ok) throw 0; })
                .catch(function () { if (++tries < 3) return new Promise(function (res) { setTimeout(res, 400 * tries); }).then(put); });
            };
            return put();
          });
        })
        .then(function () {
          self.sel = 'only'; self.panel = false; ss('kcpack:sel:' + self.parent.id, null); self.render();
          if (D && D.refresh) return D.refresh();
          document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true, detail: { openMiniCart: true } }));
        })
        .catch(function (err) { self._err(err && err.message || 'Sepete eklenemedi. Tekrar dene.'); if (D && D.close) D.close(); })
        .then(function () {
          self._busy = false;
          if (btn) { btn.removeAttribute('aria-busy'); btn.disabled = false; }
          if (D) { D.setAdding && D.setAdding(false); D.clearPending && D.clearPending(); }
          self._cta(self.sel !== 'only' ? self.byHandle[self.sel] : null);
        });
    }
  }
  window.customElements.define('kc-pack', KcPack);
})();
